import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CollectionForm from '../common/CollectionForm';
import useCollectionFormData from '../common/useCollectionFormData';

export default function CustomCollectionAdd() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    formData,
    collections,
    loading,
    draftField,
    handleInputChange,
    handleDraftFieldChange,
    addField,
    updateField,
    removeField,
    handleSubmit,
    getFieldTypeLabel,
  } = useCollectionFormData({
    onSuccess: ({ formData: savedForm }) => {
      navigate('/custom-collections', {
        state: { message: t('customCollections.add.messages.createdSuccess', { name: savedForm?.name || t('customCollections.add.messages.fallbackName') }) }
      });
    },
  });

  const handleCancel = () => navigate('/custom-collections');

  return (
    <>
      <div className="divide-y divide-gray-200 bg-white shadow sm:rounded-lg">
        <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8">
          <div>
            <h2 className="text-base/7 font-semibold text-gray-900">{t('customCollections.add.title')}</h2>
            <p className="mt-1 text-sm/6 text-gray-500">{t('customCollections.add.subtitle')}</p>
          </div>

          <CollectionForm
            formData={formData}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            loading={loading}
            draftField={draftField}
            handleDraftFieldChange={handleDraftFieldChange}
            addField={addField}
            updateField={updateField}
            removeField={removeField}
            getFieldTypeLabel={getFieldTypeLabel}
            submitLabel={t('customCollections.add.actions.submit')}
            loadingLabel={t('customCollections.add.actions.submitting')}
            onCancel={handleCancel}
            collections={collections}
          />
        </div>
      </div>
    </>
  )
}
